<template>
  <div class="content">
    <el-row type="flex" justify="start">
      <el-col :span="12">
        <el-form
          label-position="top"
          label-width="200px"
          ref="form"
          :rules="rules"
          :model="form"
        >
          <h3>零售奖励</h3>
          <el-form-item prop="retail_bonus_direct_reward_money_rate">
            <el-input
              type="number"
              v-model="form.retail_bonus_direct_reward_money_rate"
              placeholder="请输入1-100正整数"
            >
              <template slot="prepend"
                >直接奖励金额 = 下级消费商品金额 *</template
              >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="retail_bonus_direct_reward_rp_rate">
            <el-input
              type="number"
              v-model="form.retail_bonus_direct_reward_rp_rate"
              placeholder="请输入1-100正整数"
            >
              <template slot="prepend"
                >直接奖励 RP积分 = 下级消费商品RP积分 *
              </template>
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="retail_bonus_indirect_reward_money_rate">
            <el-input
              type="number"
              v-model="form.retail_bonus_indirect_reward_money_rate"
              placeholder="请输入1-100正整数"
            >
              <template slot="prepend"
                >间接奖励金额 = 下级直接奖励金额 *
              </template>
              <template slot="append">%</template></el-input
            >
          </el-form-item>
          <el-form-item label="" prop="retail_bonus_indirect_reward_rp_rate">
            <el-input
              type="number"
              v-model="form.retail_bonus_indirect_reward_rp_rate"
              placeholder="请输入1-100正整数"
            >
              <template slot="prepend"
                >间接奖励RP积分 = 下级直接奖励RP积分 *
              </template>
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-row type="flex" justify="center">
              <el-button
                type="primary"
                @click="saveConfigs"
                :loading="btnLoading"
                >保存</el-button
              >
            </el-row>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      options: [
        {
          value: '选项1',
          label: '非会员',
        },
        {
          value: '选项2',
          label: '网红',
        },
        {
          value: '选项3',
          label: '套餐A',
        },
        {
          value: '选项4',
          label: '套餐B',
        },
      ],
      btnLoading: false,
      rules: {
        retail_bonus_direct_reward_money_rate: [
          { required: true, message: '请填写', trigger: 'change' },
        ],
        retail_bonus_direct_reward_rp_rate: [
          { required: true, message: '请填写', trigger: 'change' },
        ],
        retail_bonus_indirect_reward_money_rate: [
          { required: true, message: '请填写', trigger: 'change' },
        ],
        retail_bonus_indirect_reward_rp_rate: [
          { required: true, message: '请填写', trigger: 'change' },
        ],
      },
      form: {
        retail_bonus_direct_reward_money_rate: '',
        retail_bonus_direct_reward_rp_rate: '',
        retail_bonus_indirect_reward_money_rate: '',
        retail_bonus_indirect_reward_rp_rate: '',
      },
    }
  },
  mounted() {
    this.configs()
  },
  methods: {
    configs() {
      request({
        url: '/api/backend/rewardConfig/retailBonusConfigs',
        method: 'get',
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.form = {
            retail_bonus_direct_reward_money_rate:
              Number(res.data.retail_bonus_direct_reward_money_rate) * 100,
            retail_bonus_direct_reward_rp_rate:
              Number(res.data.retail_bonus_direct_reward_rp_rate) * 100,
            retail_bonus_indirect_reward_money_rate:
              Number(res.data.retail_bonus_indirect_reward_money_rate) * 100,
            retail_bonus_indirect_reward_rp_rate:
              Number(res.data.retail_bonus_indirect_reward_rp_rate) * 100,
          }
        }
      })
    },

    saveConfigs() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/rewardConfig/saveRetailBonusConfigs',
            method: 'post',
            data: {
              retail_bonus_direct_reward_money_rate:
                Number(this.form.retail_bonus_direct_reward_money_rate) / 100,
              retail_bonus_direct_reward_rp_rate:
                Number(this.form.retail_bonus_direct_reward_rp_rate) / 100,
              retail_bonus_indirect_reward_money_rate:
                Number(this.form.retail_bonus_indirect_reward_money_rate) / 100,
              retail_bonus_indirect_reward_rp_rate:
                Number(this.form.retail_bonus_indirect_reward_rp_rate) / 100,
            },
          })
            .then((response) => {
              this.btnLoading = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
  },
}
</script>

<style>
.content {
  padding: 20px;
}
</style>
